import request from '@/services/interceptor.js'

export const get_dispositiviSicurezza = (filtri) => {
    return request({ url: '/dispositivosicurezza', method: 'get', params: filtri || {}, loadingBar: true })
}

export const get_dispositivoSicurezza = (id) => {
    return request({ url: `/dispositivosicurezza/${id}`, method: 'get', loadingBar: true })
}

export const get_dispositivoSicurezza_kpi = () => {
    return request({ url: '/dispositivosicurezza/kpi', method: 'get', loadingBar: true })
}

export const create_dispositivoSicurezza = (par) => {
    return request({ url: '/dispositivosicurezza', method: 'post', data: par, loadingBar: true })
}

export const update_dispositivoSicurezza = (id, par) => {
    return request({ url: `/dispositivosicurezza/${id}`, method: 'put', data: par, loadingBar: true })
}

export const duplica_dispositivoSicurezza = (id) => {
    return request({ url: `/dispositivosicurezza/${id}/duplica`, method: 'post', loadingBar: true })
}

export const delete_dispositivoSicurezza = (id, conferma) => {
    return request({
        url: `/dispositivosicurezza/${id}`,
        method: 'delete',
        params: { conferma: !!conferma },
        loadingBar: true
    })
}
